import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

export const getAlbumMembershipGroupPurchasesQuery = gql`
  query getAlbumMembershipGroupPurchases($id: RecordID!) {
    albumMembershipGroup(
      id: $id
      root_groups_only: true
      include_matched_photos_only: true
    ) {
      id
      purchased_photos(slice: { limit: 999 }) {
        total
        count
        records {
          id
        }
      }
      purchased_photo_downloads(slice: { limit: 999 }) {
        total
        count
        records {
          photo {
            id
          }
        }
      }
      entitled_matched_photos(slice: { limit: 999 }) {
        total
        count
        records {
          id
        }
      }
    }
  }
`;

const getAlbumMembershipGroupPurchasesOptions = {
  options: ({ albumMembershipGroupId }) => ({
    variables: {
      id: albumMembershipGroupId,
    },
    fetchPolicy: 'cache-first',
  }),
  skip: ({ albumMembershipGroupId }) => !albumMembershipGroupId,
};

const getAlbumMembershipGroupPurchases = graphql(
  getAlbumMembershipGroupPurchasesQuery,
  getAlbumMembershipGroupPurchasesOptions,
);

export default getAlbumMembershipGroupPurchases;
